import styles from './PrereadFeedback.module.scss'

import Button from '@/components/Button'

const FeedbackError = ({ onRetry, detail = false }: { onRetry: () => void; detail?: boolean }) => (
  <div className={styles.error} role="alert">
    <p>Couldn’t load {detail ? 'this preread report' : 'preread feedback'}. Try again.</p>
    <Button title="Try again" type="light" onClick={onRetry} />
  </div>
)

export default FeedbackError
